export const maskSSN = (SSN: string | null) => {
	const _ssn = SSN?.substring(5, 9);
	return _ssn;
};
